import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                toggler: 'toggle',
                filter: 'filter',
                close: 'close'
            }
        }

    }

    init() {

        this.$count = this.$('count')[0];
        this.$label = this.$('label')[0];
        this.$name = this.$('name')[0];

        this.$wrap = this.$('wrap')[0];
        this.$inner = this.$('inner')[0];

        if(html.getAttribute('data-template') === 'home') {
            html.setAttribute('data-filter', 'category-all');
        }

        this.$pageThumbnail = document.getElementsByClassName('js-page-thumbnail')[0];
        this.$pageVisual = document.getElementsByClassName('js-page-visual')[0];
        this.$pageVideo = document.getElementsByClassName('js-page-video')[0];
        this.$pageTagline = document.getElementsByClassName('js-page-tagline')[0];

        this.$nextCategoryVideo = document.getElementsByClassName('js-next-category-video')[0];
        this.$nextCategoryName = document.getElementsByClassName('js-next-category-name')[0];
        this.$nextCategoryCount = document.getElementsByClassName('js-next-category-count')[0];
        this.$nextCategorySummary = document.getElementsByClassName('js-next-category-summary')[0];

        this.isOpen = false;

        // if (this.getHash() !== '') {
        //     gsap.delayedCall(0.7, () => {
        //         this.filter({
        //             currentTarget: document.querySelector(`[data-filters="filter"][data-category="${this.getHash()}"]`)
        //         }, false);
        //     });
        // }
    }

    filter(e, toggle = true, scrollTo = true, updatePage = true) {
        let el = e.currentTarget;

        for(let filter of this.$('filter')) {
            filter.classList.remove('is-active')
        }
        el.classList.add('is-active');

        if (this.filterCall !== undefined) {
            this.filterCall.kill();
        }

        this.call('filter', {
            filteredCategory: el.getAttribute('data-category'),
            scrollTo: scrollTo
        }, 'ProjectList');

        const url = el.getAttribute('data-url')
        if(url) {
            this.call('goTo', { url, transition: 'filter' }, 'Load')
            return;
        }

        if (toggle) {
            this.toggle();
        }

        this.$count.innerText = el.getAttribute('data-count');
        this.$label.innerText = el.getAttribute('data-label');

        this.filterCall = gsap.delayedCall(0.3, () => {
            if (el.getAttribute('data-category') === 'category-all') {
                this.el.classList.remove('has-filter');
            } else {
                this.el.classList.add('has-filter');
            }
        });

        if(updatePage) {
            if(el.getAttribute('data-theme')) {
                html.setAttribute('data-theme', el.getAttribute('data-theme'));
                document.querySelector('[data-load-container]').setAttribute('data-theme', el.getAttribute('data-theme'));
            }

            if(el.getAttribute('data-visual')) {
                this.$pageVisual.style.backgroundImage = `url('${el.getAttribute('data-visual')}')`;
            }

            if(el.getAttribute('data-thumbnail')) {
                this.$pageThumbnail.src = el.getAttribute('data-thumbnail');
            }

            if(el.getAttribute('data-video')) {
                this.$pageVideo.src = el.getAttribute('data-video');
            }

            if(el.getAttribute('data-tagline')) {
                this.$pageTagline.innerText = el.getAttribute('data-tagline');
            }

            if(el.getAttribute('data-next-category-name')) {
                this.$nextCategoryName.innerText = el.getAttribute('data-next-category-name');
            }

            if(el.getAttribute('data-next-category-count')) {
                this.$nextCategoryCount.innerText = el.getAttribute('data-next-category-count');
            }

            if(el.getAttribute('data-next-category-summary')) {
                this.$nextCategorySummary.innerText = el.getAttribute('data-next-category-summary');
            }

            if(el.getAttribute('data-next-category-video')) {
                this.$nextCategoryVideo.src = el.getAttribute('data-next-category-video');
            }
        }

        html.setAttribute('data-filter',el.getAttribute('data-category'));
    }

    toggle() {

        if (!this.isOpen) {
            this.open();
        } else {
            this.close();
        }
    }

    open() {
        gsap.to(this.$wrap, {
            duration: 0.3,
            height: this.$inner.getBoundingClientRect().height,
            onComplete: () => {
                this.call('update', {}, 'Scroll', 'main');
            }
        });

        this.isOpen = true;
        this.el.classList.add('is-open');
    }

    close() {
        gsap.to(this.$wrap, {
            duration: 0.3,
            height: 0,
            onComplete: () => {
                this.call('update', {}, 'Scroll', 'main');
            }
        });

        this.isOpen = false;

        this.el.classList.remove('is-open');
    }

    getHash() {
        return location.hash.substring(1);
    }
}
